import { Action, createReducer, on } from '@ngrx/store';
import {
    getDocDueDateFailure,
    getDocDueDateSuccess,
    getQmAssociationClientPortalVisibilitySettingsFailure,
    getQmAssociationClientPortalVisibilitySettingsSuccess,
    getQmAssociationFailure,
    getQmAssociationsFailure,
    getQmAssociationsSuccess,
    getQmAssociationSuccess,
    updateDocDueDateFailure,
    updateQmAssociationClientPortalVisibilitySettingsFailure,
    createQmAssociationFailure,
    bulkUnassignComplianceLiaisonFromQmAssociationSuccess,
    bulkUnassignComplianceLiaisonFromQmAssociationFailure,
    bulkUpdateComplianceLiaisonFromQmAssociationSuccess,
    bulkUpdateComplianceLiaisonFromQmAssociationFailure,
    createQmAssociationSuccess,
    bulkQmAssociationAssignmentChange,
    bulkQmAssociationAssignmentChangeFailure,
    bulkQmAssociationAssignmentChangeSuccess,
    updateQmAssociationNameSuccess,
    updateQmAssociationNameFailure,
    getAssociationAutomatchSettingsSuccess,
    clearLocalAssociationAutomatchSettings,
    updateAssociationAutomatchSettingsSuccess,
    updateAssociationAutomatchSettingsFailure
} from 'src/app/compliance/store/actions/qm-associations.actions';
import { QmAssociationsState } from '../state/qm-associations.state';

const initialState: QmAssociationsState = {
    qmAssociations: undefined,
    qmAssociation: undefined,
    clientPortalVisibilitySettings: undefined,
    docDueDate: undefined,
    reloadQMAssociationsGrid: undefined,
    isLoading: false,
    isComplete: false,
    automatchSettings: undefined
};

const reducer = createReducer(
    initialState,

    on(getQmAssociationsSuccess, (state, action) => ({
        ...state,
        qmAssociations: action.associations,
        reloadQMAssociationsGrid: false
    })),

    on(getQmAssociationSuccess, (state, action) => ({
        ...state,
        qmAssociation: action.association
    })),

    on(getQmAssociationClientPortalVisibilitySettingsSuccess, (state, action) => ({
        ...state,
        clientPortalVisibilitySettings: action.clientPortalVisibilitySettings
    })),

    on(getDocDueDateSuccess, (state, action) => ({
        ...state,
        docDueDate: action.docDueDate ?? undefined
    })),

    on(
        getQmAssociationsFailure,
        getQmAssociationFailure,
        getQmAssociationClientPortalVisibilitySettingsFailure,
        updateQmAssociationClientPortalVisibilitySettingsFailure,
        getDocDueDateFailure,
        updateDocDueDateFailure,
        (state, action) => ({
            ...state,
            error: action.error
        })
    ),

    on(
        bulkUnassignComplianceLiaisonFromQmAssociationSuccess,
        bulkUnassignComplianceLiaisonFromQmAssociationFailure,
        bulkUpdateComplianceLiaisonFromQmAssociationSuccess,
        bulkUpdateComplianceLiaisonFromQmAssociationFailure,
        createQmAssociationFailure,
        createQmAssociationSuccess,
        updateQmAssociationNameSuccess,
        updateQmAssociationNameFailure,
        (state) => ({
            ...state,
            reloadQMAssociationsGrid: true
        })
    ),

    on(bulkQmAssociationAssignmentChange, (state) => ({
        ...state,
        isLoading: true
    })),

    on(bulkQmAssociationAssignmentChangeSuccess, (state) => ({
        ...state,
        isLoading: false,
        error: undefined
    })),

    on(bulkQmAssociationAssignmentChangeFailure, (state, action) => ({
        ...state,
        isLoading: false,
        error: JSON.stringify(action.error)
    })),

    on(getAssociationAutomatchSettingsSuccess, (state, action) => ({
        ...state,
        automatchSettings: action.settings
    })),

    on(updateAssociationAutomatchSettingsSuccess, (state, action) => ({
        ...state,
        automatchSettings: action.settings
    })),

    on(clearLocalAssociationAutomatchSettings, (state) => ({
        ...state,
        automatchSettings: undefined
    })),

    on(updateAssociationAutomatchSettingsFailure, (state, action) => ({
        ...state,
        error: { ...action.error as any }
    }))
);

export function qmAssociationsReducer(state: QmAssociationsState | undefined, action: Action) {
    return reducer(state, action);
}
